import { element as ngElement } from 'angular';
import { Directive, Inject, OnInit } from 'angular-ts-decorators';

@Directive({
  selector: '[compareBasketPosition]',
})
export class CompareBasketPositionDirective implements OnInit {
  public static $inject: ReadonlyArray<string> = ['$scope', '$element', '$window'];

  constructor(
    @Inject('$scope') private $scope: ng.IScope,
    @Inject('$element') private $element: JQLite,
    @Inject('$window') private $window: ng.IWindowService
  ) { }

  public ngOnInit(): void {
    const html: HTMLElement = document.documentElement;
    const breadcrumbsItem: HTMLElement = document.querySelector('.breadcrumbs');
    const positionClass = 'compare-basket--fixed';
    const breadcrumbsHeight: number = breadcrumbsItem ? breadcrumbsItem.offsetHeight : 0;

    const toggleClass = (): void => {
      const footer: HTMLElement = document.getElementsByTagName('footer')[0];

      if (html.scrollTop + this.$window.innerHeight < (footer.offsetTop - breadcrumbsHeight)) {
        this.$element.addClass(positionClass);
      } else {
        this.$element.removeClass(positionClass);
      }
    };

    ngElement(this.$window).bind(
      'load touchmove scroll',
      (): void => {
        toggleClass();
        this.$scope.$apply();
      },
    );
  }
}
